import React, { useState } from 'react';
import { Layout, Card } from 'antd';
import PageTitle from 'shared_components/page_title';

import SearchCustForm from "./searchCustForm";
import SearchCustTable from "./searchCustTable";
import SearchPager from 'shared_components/search_pager';
import { GLOBAL_TABLE_PAGE_SIZE } from 'global_config/constant-global';

import '../customer.css';

const {Content} = Layout;

function SearchCustomer() {
    const [data, setData] = useState([]);
    const [pageSize, setPageSize] = useState(GLOBAL_TABLE_PAGE_SIZE)

    function search(payload) {
        setData(payload);
    }

    const handleChangeSize = (pageSize) => {
        // console.log(`pageSize => ${pageSize}`);
		setPageSize(pageSize)
	}

    return (
        <div>
            <Card>
            <PageTitle pageTitle="CUSTOMER SETUP" />
            <Content>
                <SearchCustForm onFinish={ search }  />
                <SearchPager 
                    pageTotal={data.length === null ? 0 : data.length}
                    pageSize={pageSize}
                    handleChangeSize={handleChangeSize}
                />
                <SearchCustTable data={data} pageSize={pageSize}/>
            </Content>
            </Card>
        </div>
    );
}

export default SearchCustomer;